import Layout from "./Layout.jsx";

import Dashboard from "./Dashboard";
import Lessons from "./Lessons";
import Lesson from "./Lesson";
import CheckIn from "./CheckIn";
import Progress from "./Progress";
import Impostazioni from "./Impostazioni";
import Exercises from "./Exercises";
import FileUpload from "./FileUpload";
import AdminLessons from "./AdminLessons";
import Setup from "./Setup";
import Landing from "./Landing";
import Calculator from "./Calculator";

// ⭐️ NEW: pagina tutorial
import Tutorial from "./Tutorial";

// ⭐️ NEW: Rileggi Esercizi
import ExerciseHistory from "./ExerciseHistory";
// ⭐️ NEW: Dettaglio singolo esercizio
import ExerciseView from "./ExerciseView";

import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";

// 🔐 Gate admin (password / admin key)
import AdminGate from "@/components/admin/AdminGate.jsx";

// ⭐️ NUOVO: auth client per collegamento a bububu
import { AuthProvider } from "@/components/AuthProvider";
import RequireAuth from "@/components/RequireAuth";
import Login from "./Login"; // pagina login username+password

const PAGES = {
  Dashboard,
  Lessons,
  Lesson,
  CheckIn,
  Progress,
  Impostazioni,
  Exercises,
  FileUpload,
  AdminLessons,
  Setup,
  Landing,
  Calculator,
  // ⬇️ Aggiunte per step 2
  ExerciseHistory,
  ExerciseView,
};

function _getCurrentPage(url) {
  if (url.endsWith("/")) url = url.slice(0, -1);
  let urlLastPart = url.split("/").pop();
  if (urlLastPart.includes("?")) urlLastPart = urlLastPart.split("?")[0];

  const pageName = Object.keys(PAGES).find(
    (page) => page.toLowerCase() === urlLastPart.toLowerCase()
  );
  return pageName || Object.keys(PAGES)[0]; // Dashboard di fallback
}

// Contenuto dentro il Router (rotte dell'app)
function PagesContent() {
  const location = useLocation();
  const currentPage = _getCurrentPage(location.pathname);

  return (
    <Layout currentPageName={currentPage}>
      <Routes>
        {/* Home */}
        <Route path="/" element={<Dashboard />} />

        {/* ====== ROTTE PUBBLICHE (alias lower/upper) ====== */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/Dashboard" element={<Dashboard />} />

        <Route path="/lessons" element={<Lessons />} />
        <Route path="/Lessons" element={<Lessons />} />

        <Route path="/lesson" element={<Lesson />} />
        <Route path="/Lesson" element={<Lesson />} />

        <Route path="/checkin" element={<CheckIn />} />
        <Route path="/CheckIn" element={<CheckIn />} />

        <Route path="/progress" element={<Progress />} />
        <Route path="/Progress" element={<Progress />} />

        <Route path="/impostazioni" element={<Impostazioni />} />
        <Route path="/Impostazioni" element={<Impostazioni />} />

        <Route path="/exercises" element={<Exercises />} />
        <Route path="/Exercises" element={<Exercises />} />

        {/* ⭐️ NEW: Rileggi Esercizi */}
        <Route path="/exerciselog" element={<ExerciseHistory />} />
        <Route path="/ExerciseLog" element={<ExerciseHistory />} />
        <Route path="/exercise-history" element={<ExerciseHistory />} />

        {/* ⭐️ NEW: Dettaglio singolo esercizio */}
        <Route path="/exercise-view" element={<ExerciseView />} />
        <Route path="/ExerciseView" element={<ExerciseView />} />

        <Route path="/landing" element={<Landing />} />
        <Route path="/Landing" element={<Landing />} />

        <Route path="/calculator" element={<Calculator />} />
        <Route path="/Calculator" element={<Calculator />} />

        {/* ⭐️ NEW: tutorial prima del setup */}
        <Route path="/tutorial" element={<Tutorial />} />

        {/* Setup (Layout già gestisce la UI speciale per Setup) */}
        <Route path="/setup" element={<Setup />} />
        <Route path="/Setup" element={<Setup />} />

        {/* ====== PAGINA SBLOCCO ADMIN ====== */}
        <Route path="/admingate" element={<AdminGate />} />
        <Route path="/AdminGate" element={<AdminGate />} />

        {/* ====== ROTTE ADMIN PROTETTE ======
             Wrappate in <AdminGate> (richiede ADMIN_KEY valida) */}
        <Route
          path="/adminlessons"
          element={
            <AdminGate>
              <AdminLessons />
            </AdminGate>
          }
        />
        <Route
          path="/AdminLessons"
          element={
            <AdminGate>
              <AdminLessons />
            </AdminGate>
          }
        />

        <Route
          path="/fileupload"
          element={
            <AdminGate>
              <FileUpload />
            </AdminGate>
          }
        />
        <Route
          path="/FileUpload"
          element={
            <AdminGate>
              <FileUpload />
            </AdminGate>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}

export default function Pages() {
  return (
    <Router>
      {/* ⭐️ NUOVO: strato auth complessivo */}
      <AuthProvider>
        <Routes>
          {/* login pubblico (username+password) */}
          <Route path="/login" element={<Login />} />

          {/* tutto il resto è protetto: se guest → redirect a /consenso sul sito */}
          <Route
            path="/*"
            element={
              <RequireAuth>
                <PagesContent />
              </RequireAuth>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}
